document.addEventListener("DOMContentLoaded", () => {
  const addItemBtn = document.getElementById("haircare-add-item");
  const itemsTable = document.querySelector("#haircare-items-table-body");
  const itemTemplate = document.getElementById("haircare-item-template");

  if (addItemBtn) {
    addItemBtn.addEventListener("click", () => {
      if (!itemTemplate) return;

      const newRowHtml = itemTemplate.innerHTML;
      const uniqueIndex = new Date().getTime();
      const rowHtml = newRowHtml.replace(/NEW_RECORD/g, uniqueIndex);

      const tempDiv = document.createElement("tbody");
      tempDiv.innerHTML = rowHtml.trim();
      const newRow = tempDiv.firstElementChild;

      // Reset values for new row
      newRow.querySelectorAll("input, select").forEach(input => {
        if (["text", "number", "date"].includes(input.type)) input.value = "";
        if (input.classList.contains("haircare-destroy-flag")) input.value = "0";
      });

      itemsTable.appendChild(newRow);
    });
  }

  if (itemsTable) {
    // Handle remove link
    itemsTable.addEventListener("click", (e) => {
      const removeLink = e.target.closest(".haircare-remove-item");
      if (removeLink) {
        const row = removeLink.closest("tr");
        const destroyFlag = row.querySelector(".haircare-destroy-flag");
        if (destroyFlag) {
          destroyFlag.value = "1";
          row.style.display = "none";
        } else {
          row.remove();
        }
      }
    });
  }
});
